import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ZapIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
export function PricingSection() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48119785324714:1';
  return <section id="compra" className="py-16 px-4 bg-gray-900 scroll-mt-20" data-id="element-149">
      <div className="max-w-2xl mx-auto text-center" data-id="element-150">
        {/* Urgency headline */}
        <p className="inline-block bg-red-600 text-white text-sm font-black uppercase tracking-widest px-5 py-2 rounded-full mb-6 animate-pulse" data-id="element-151">
          🔥 ÚLTIMOS CUPOS A ESTE PRECIO
        </p>

        <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-152">
          Llevate todo el MegaPack
        </h2>
        <p className="text-lg text-gray-400 mb-8" data-id="element-153">
          6 Tomos + 4 Bonos de regalo — Todo incluido
        </p>

        {/* Price block */}
        <div className="bg-gray-800 rounded-2xl border-2 border-yellow-500 p-8 md:p-10 mb-8 shadow-2xl" data-id="element-154">
          <p className="text-gray-400 text-lg font-bold mb-1" data-id="element-155">
            Valor total:{' '}
            <span className="line-through text-gray-500" data-id="element-156">$42.000</span>
          </p>
          <p className="text-red-500 text-xl font-black uppercase tracking-wider mb-3" data-id="element-157">
            HOY PAGÁS SOLO:
          </p>
          <p className="text-6xl md:text-8xl font-black text-yellow-500 tracking-tighter mb-1" data-id="element-158">
            $19.990
          </p>
          <p className="text-sm text-gray-500 font-medium mb-6" data-id="element-159">
            Pesos argentinos · Un solo pago · Sin suscripción
          </p>

          {/* Savings callout */}
          <div className="inline-block bg-green-600/20 border border-green-500/40 text-green-400 font-black text-lg px-6 py-2 rounded-full mb-8" data-id="element-160">
            AHORRÁS $22.010 🎉
          </div>

          {/* CTA */}
          <CTAButton href={CHECKOUT_URL} text="👉 QUIERO MI MEGAPACK AHORA" subtext="✅ Acceso inmediato después del pago" data-id="element-161" />

          {/* Trust signals */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-8" data-id="element-162">
            <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-163">
              <ZapIcon className="w-5 h-5 text-yellow-500" data-id="element-164" />
              <span className="text-xs font-bold" data-id="element-165">Acceso inmediato</span>
            </div>
            <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-166">
              <DownloadIcon className="w-5 h-5 text-yellow-500" data-id="element-167" />
              <span className="text-xs font-bold" data-id="element-168">Descarga digital</span>
            </div>
            <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-169">
              <InfinityIcon className="w-5 h-5 text-yellow-500" data-id="element-170" />
              <span className="text-xs font-bold" data-id="element-171">Acceso de por vida</span>
            </div>
            <div className="flex flex-col items-center gap-1 text-gray-400" data-id="element-172">
              <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-173" />
              <span className="text-xs font-bold" data-id="element-174">Garantía 30 días</span>
            </div>
          </div>
        </div>

        {/* What's included - compact */}
        <div className="text-left bg-gray-800/50 rounded-xl p-6 border border-gray-700 mb-8" data-id="element-175">
          <p className="text-white font-black text-lg mb-4 text-center" data-id="element-176">
            📦 Incluye:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2" data-id="element-177">
            <p className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-178">
              <span className="text-green-500" data-id="element-179">✔</span> Tomo 1 — Fundamentos
              Pro
            </p>
            <p className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-180">
              <span className="text-green-500" data-id="element-181">✔</span> Tomo 2 — El Arte Del
              Pulido
            </p>
            <p className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-182">
              <span className="text-green-500" data-id="element-183">✔</span> Tomo 3 — Interiores
              Extremos
            </p>
            <p className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-184">
              <span className="text-green-500" data-id="element-185">✔</span> Tomo 4 — Química y
              Costos
            </p>
            <p className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-186">
              <span className="text-green-500" data-id="element-187">✔</span> Tomo 5 — El Negocio
              Cash
            </p>
            <p className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-188">
              <span className="text-green-500" data-id="element-189">✔</span> Tomo 6 — Protección y
              Sellado
            </p>
            <p className="flex items-center gap-2 text-yellow-400 text-sm font-bold" data-id="element-190">
              <span data-id="element-191">🎁</span> Bono 1 — Kit De Checklists
            </p>
            <p className="flex items-center gap-2 text-yellow-400 text-sm font-bold" data-id="element-192">
              <span data-id="element-193">🎁</span> Bono 2 — Presupuesto Pro
            </p>
            <p className="flex items-center gap-2 text-yellow-400 text-sm font-bold" data-id="element-194">
              <span data-id="element-195">🎁</span> Bono 3 — Calculadora
            </p>
            <p className="flex items-center gap-2 text-yellow-400 text-sm font-bold" data-id="element-196">
              <span data-id="element-197">🎁</span> Bono 4 — Fotos Que Venden
            </p>
          </div>
        </div>

        {/* Guarantee */}
        <div className="flex items-center justify-center gap-3 text-gray-400 text-sm" data-id="element-198">
          <ShieldCheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-199" />
          <p data-id="element-200">
            <span className="font-bold text-white" data-id="element-201">Garantía de 30 días.</span>{' '}
            Si no es para vos, te devolvemos el 100%. Sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}